module.exports = __webpack_public_path__ + "static/media/file.694da481.png";